import { ValueFormatterParams } from "@ag-grid-community/core";
import { DeleteOutlined } from "@ant-design/icons";
import { Modal, Tooltip } from "antd";
import { ForwardedRef, forwardRef } from "react";
import useApi from "../../../hooks/useApi";
import workItemState from "../../../api/WorkItemState";
import AGSelect from "./AGSelect";


export const getWorkItemStateDefs = ({ getData, selectedProduct, categoryList, descriptionOptions }: any) => {

    const ActionButton = (props: ValueFormatterParams<any, any>) => {
        const deleteWorkItemStateApi = useApi(workItemState.deleteWorkItemState)

        const handleOk = async () => {
            const response = await deleteWorkItemStateApi.request(selectedProduct, `${props?.data?.state}`)
            if (response?.data) {
                getData();
            }
        }

        const handleAction = () => {
            Modal.confirm({
                title: `Do you want to delete ${props?.data?.state}  work item state?`,
                content: "This action cannot be undone.",
                okText: "Yes",
                cancelText: "No",
                onOk: () => {
                    handleOk()
                },
            });
        };

        return (
            <>
                <Tooltip title={'Delete'}>
                    {props?.data?.state && <DeleteOutlined onClick={() => handleAction()} />}
                </Tooltip>
            </>
        )
    }

    let columns = [
        {
            headerName: "State Category",
            field: "category",
            headerTooltip: "State Category",
            tooltipField: "category",
            cellStyle: { "cursor": "pointer" },
            cellClass: 'border-right',
            show: true,
            filter: 'agMultiColumnFilter',
            menuTabs: ['filterMenuTab', 'generalMenuTab'],
            filterParams: {
                filters: [
                    {
                        filter: 'agTextColumnFilter',
                        filterParams: {
                            textMatcher: (data: any) => {
                                return data?.data?.category?.toString()?.toLowerCase().includes(data.filterText.toLowerCase());
                            },
                        }
                    },
                    {
                        filter: 'agSetColumnFilter',
                        filterParams: {
                            convertValuesToStrings: true,
                            keyCreator: (params: any) => params?.value,
                        }
                    },
                ],
            },
            cellDataType: "object",
            cellEditor: forwardRef((params: any, ref: ForwardedRef<any>) => {
                const stopEditing = () => {
                    params.stopEditing();
                };
                return <AGSelect data={params?.data} value={params.value} stopEditing={stopEditing} onChange={params.onChange} ref={ref} params={params} options={categoryList} />;
            }),
            valueFormatter: (props: ValueFormatterParams<any, any>) => {
                return props?.value ?
                    typeof props?.value === "object"
                        ? props?.value?.children !== null
                            ? props?.value?.children
                            : ""
                        : props?.value
                    : null;
            },
            // valueGetter: (params: any) => params?.data?.category?.children ?? params?.data?.category,
            editable: true,
              
        },
        {
            headerName: "State",
            field: "state",
            headerTooltip: "State",
            tooltipField: "state",
            cellStyle: { "cursor": "pointer" },
            cellClass: 'border-right',
            show: true,
            filter: 'agMultiColumnFilter',
            menuTabs: ['filterMenuTab', 'generalMenuTab'],
            editable: true
        },
        {
            headerName: "Description",
            field: "state_description",
            headerTooltip: "Description",
            tooltipField: "state_description",
            show: true,
            cellClass: 'border-right',
            filter: 'agMultiColumnFilter',
            menuTabs: ['filterMenuTab', 'generalMenuTab'],
            editable: true,
            cellDataType: "object",
            filterParams: {
                filters: [
                    {
                        filter: 'agTextColumnFilter',
                        filterParams: {
                            textMatcher: (data: any) => {
                                return data?.data?.state_description?.toString()?.toLowerCase().includes(data.filterText.toLowerCase());
                            },
                        }
                    },
                    {
                        filter: 'agSetColumnFilter',
                        filterParams: {
                            convertValuesToStrings: true,
                           keyCreator: (params: any) => params?.value,
                        }
                    },
                ],
            },
            cellEditor: forwardRef((params: any, ref: ForwardedRef<any>) => {
                const stopEditing = () => {
                    params.stopEditing();
                };
                return <AGSelect data={params?.data} value={params.value} stopEditing={stopEditing} onChange={params.onChange} ref={ref} params={params} options={descriptionOptions} />;
            }),
            valueFormatter: (props: ValueFormatterParams<any, any>) => {
                return props?.value ?
                    typeof props?.value === "object"
                        ? props?.value?.children !== null
                            ? props?.value?.children
                            : ""
                        : props?.value
                    : null;
            },

        },
        {
            field: "action",
            headerName: "",
            editable: false,
            sortable: false,
            filter: false,
            show: true,
            maxWidth: 50,
            minWidth: 50,
            resizable: false,
            cellStyle: () => { return { cursor: "pointer" } },
            cellRenderer: ActionButton,
        },
    ]

    return (
        columns
    )
}